import * as React from "react";
import { connect } from "react-redux";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import CustomerServiceInfo from "./CustomerServiceInfo";
import * as queryString from 'query-string';

//Below are possible querystring params that can come from url.
const TAB_LIST = ['mr', 'fc'];

class CustomerService extends React.Component {
    constructor(props) {
        super(props);
        this.toggleTabs = this.toggleTabs.bind(this);
        const { location } = this.props;
        this.tabList = ['mr'];
        const searchParams = location.search ? queryString.parse(location.search) : location.searchParms ? queryString.parse(location.searchParms) : null;
        const tabParam = searchParams && typeof searchParams.tab !== "undefined" && searchParams.tab ? searchParams.tab.toLowerCase() : null;
        const activeTabName = tabParam && TAB_LIST.indexOf(tabParam) !== -1 ? tabParam : 'mr';
        this.state = { activeTab: activeTabName };
        this.navRow = React.createRef()
    }

    componentDidMount() {
        logUI("MBHWeb.UI.CustomerService.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    //Get Active tab classname
    getActiveTabClassName(tabName) {
        const { activeTab } = this.state;
        return activeTab === tabName.toLowerCase() ? "active" : "";
    }

    toggleTabs(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({ activeTab: tab });
        }
        //scroll horizontal menu item into view on mobile
        if (tab === 'mr') {
            if (this.navRow.current) {
                if (this.navRow.current) {
                    this.navRow.current.scrollLeft = 0
                }
            }
        }
        else if (tab === 'fc') {
            if (this.navRow.current) {
                if (this.navRow.current) {
                    this.navRow.current.scrollLeft = 100
                }
            }
        }
    }

    render() {
        const { technicalHelpDeskNumber, technicalHelpDeskHours, hasSWHP, hasFirstCare, serverData, insuranceName } = this.props;
        const { activeTab } = this.state;
        const enableNewHealthPlan = serverData && serverData.enableNewHealthPlan;

        return (
            <div className="container-fluid body-content customerservice-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div id="top" />
                        <div className="row">
                            <div className="col-12">
                                <div className="page-heading">Customer Service</div>
                            </div>
                        </div>
                        {enableNewHealthPlan ?
                            <><div className="row">
                                <div className="col-12 nav-row" ref={this.navRow}>
                                    <Nav tabs>

                                        <NavItem>
                                            <NavLink className={this.getActiveTabClassName("mr")} onClick={() => this.toggleTabs("mr")}>
                                                MEDICAL RECORDS
                                            </NavLink>
                                        </NavItem>
                                        {
                                            (hasSWHP || hasFirstCare) &&
                                            <NavItem>
                                                <NavLink className={this.getActiveTabClassName("fc")} onClick={() => this.toggleTabs("fc")}>
                                                    {insuranceName ? insuranceName.toUpperCase() : hasSWHP ? "BAYLOR SCOTT & WHITE HEALTH PLAN" : "FIRSTCARE HEALTH PLANS"}
                                                </NavLink>
                                            </NavItem>

                                        }
                                    </Nav>
                                </div>
                            </div>
                                <div className="row">
                                    <div className="col-12">

                                        <TabContent activeTab={activeTab}>
                                            <TabPane tabId="mr">
                                                <CustomerServiceInfo technicalHelpDeskHours={technicalHelpDeskHours} technicalHelpDeskNumber={technicalHelpDeskNumber} enableNewHealthPlan={enableNewHealthPlan} />
                                            </TabPane>
                                            {
                                                (hasSWHP || hasFirstCare) &&
                                                <TabPane tabId="fc">
                                                    <CustomerServiceInfo technicalHelpDeskHours={technicalHelpDeskHours} hasSWHP={hasSWHP} insuranceName={insuranceName} hasFirstCare={hasFirstCare} enableNewHealthPlan={enableNewHealthPlan} />
                                                </TabPane>
                                            }
                                        </TabContent>
                                    </div>
                                </div></>
                            : <CustomerServiceInfo technicalHelpDeskHours={technicalHelpDeskHours} technicalHelpDeskNumber={technicalHelpDeskNumber} enableNewHealthPlan={enableNewHealthPlan} />
                        }
                    </div>
                </div>
            </div>

        );
    }
};

const mapStateToProps = (state) => {
    return {
        serverData: state.session.serverData,
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : "",
        technicalHelpDeskHours: state.session.serverData ? state.session.serverData.technicalHelpDeskHours:"",
        hasSWHP: state.memberships.hasAnySWHP,
        hasFirstCare: state.memberships.hasFC,
        insuranceName: state.session.insuranceName
    };
};

const mapDispatchToProps = (dispatch) => {
    return {

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerService);